export const IMAGE_SIZE = 3145728; // bytes
export const VIDEO_SIZE = 31457280; // bytes

export const IMAGE_CATEGORY = {
  coverImage: 1,
  logo: 2,
  profileImage: 3,
};
